import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'

import { App } from './App'
import './estilos.css'
import './estilos-prediccion.css'
import './estilos-resumen.css'

createRoot(document.getElementById('raiz')!).render(
  <StrictMode>
    <App />
  </StrictMode>,
)
